import { useState } from "react"
import { useDispatch } from "react-redux"
import { deleteTimeOff, getCalendarTimeOff } from "store/calendar"
import { toaster } from "components/common/Toast"
import { useRefreshCalendarBookings } from "pagesV2/pro/Calendar/useRefreshCalendarBookings"

/**
 * Custom hook for handling time-off deletion logic
 * @param {Object} options - Configuration options
 * @param {Function} options.setEditingTimeOffItem - Function to clear editing item
 * @param {Object} options.form - Form instance to reset
 * @param {string} options.timeOffType - Type of time-off for refresh
 * @param {Object} options.dates - Dates for bookings refresh
 * @returns {Object} Deletion handlers and modal state
 */
export const useTimeOffDeletion = ({ setEditingTimeOffItem, form, timeOffType, profileId }) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const dispatch = useDispatch()
  const refreshCalendarBookings = useRefreshCalendarBookings()

  const handleDeleteTimeOff = (id = null) => {
    setDeleteId(id)
    setIsDeleteModalOpen(true)
  }

  const handleCancelDeleteTimeOff = () => {
    setIsDeleteModalOpen(false)
    setDeleteId(null)
  }

  const handleYesDeleteTimeOff = () => {
    dispatch(deleteTimeOff(deleteId, profileId)).then((response) => {
      if (response?.message) {
        toaster.success(response.message)
      }
      setEditingTimeOffItem(null)
      const currentCrewMemberId = form.getFieldValue("crew_member_id")
      form.resetFields()
      form.setFieldsValue({ crew_member_id: currentCrewMemberId })
      dispatch(getCalendarTimeOff({ ui_type: timeOffType }, profileId))
      refreshCalendarBookings()
      setIsDeleteModalOpen(false)
      setDeleteId(null)
    })
  }

  return {
    isDeleteModalOpen,
    handleDeleteTimeOff,
    handleCancelDeleteTimeOff,
    handleYesDeleteTimeOff
  }
}
